module.exports = __webpack_public_path__ + "static/media/dude.8615288f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phaser-assets/sprites/dude.png
// module id = 994
// module chunks = 0